import { render, staticRenderFns } from "./tableSkeleton.vue?vue&type=template&id=e92fbac2&scoped=true"
import script from "./tableSkeleton.vue?vue&type=script&lang=js"
export * from "./tableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./tableSkeleton.vue?vue&type=style&index=0&id=e92fbac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92fbac2",
  null
  
)

export default component.exports